<template>
    <div class="rp-messenger-help-with-other-issues-header">
        <OrderItem
            v-if="orderHasData"
            class="rp-messenger-order-head-card"
            :orderData="selectedOrderData"
            :showTopHeaderOnly="true"
            :actionsList="actionsList"
            @action="handleOrderAction"
            :showViewButton="false"
        />
        <div class="rp-scenario-header"
            :class="{'first-screen':breadCrumbHandler.length == 2}"
            :style="{
                background:breadCrumbHandler.length == 2 ? '#f9f9f9' : ''
            }"
        >
            <ScenarioBackButton v-if="breadCrumbHandler.length != 2" />
            <div :class="this.breadCrumbHandler.length == 2 ? 'rp-scenario-main-header' : ''">
                {{ scenarioHeaderText }}
            </div>
        </div>
        <div
            :key="index"
            :name="index"
            class="rp-messenger-order-help-with-other-issues disable-select"
            v-for="(issue, index) in listOfIssues"
            >
            <div
                    @click="$emit('handleParentScenarioClick', issue)"
                    class="rp-messenger-order-list-item-trigger"
                >
                <span class="label">{{ issue.scenarioName }}</span>
                <span class="icon">
                    <i class="el-icon-arrow-right scenario-right-arrow"></i>
                </span>
            </div>

        </div>
    </div>
</template>

<script>
const defaultActions = [
    {          
        buttonLabel: 'view',
        actionName: 'onOrderClick'
    },
    {
        buttonLabel: 'track',
        actionName: 'onOrderTrackUrlClick',
    }
]
export default {
    props: {
        listOfIssues: {
            type: Array,
        },
        activeColor: {
            type: String,
            required: true
        },
        headerText:{
            type:String
        },
        selectedOrderData: {
            type: Object,
            required: false,
        },
        actionsList: {
            type: Array,
            default: () => defaultActions,
        },
        breadCrumbHandler: Array,
        helpcenterHeader: {
            type: String,
            default: "",
        }
    },
    components: {},
    computed: {
        orderHasData() {
            return this.selectedOrderData && Object.keys(this.selectedOrderData).length ? true : false;
        },
        scenarioHeaderText() {
            return this.breadCrumbHandler.length == 2 ? (this.helpcenterHeader || this.$t('homeScreen.allTopics')) : this.headerText
        }
    },
    methods: {
        handleOrderAction({ actionName, payload }) {
			this.$emit(actionName, payload)
    	},
    }
};
</script>

<style lang="scss" scoped>
    .rp-messenger-help-with-other-issues-header {
        margin: 16px;
        width: calc(100% - 32px);
        border-radius: 5px;
        background: #fff;
        height: unset;
        box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1),
        inset 0 2px 0 0 rgba(220, 219, 236, 0);
        .rp-scenario-header {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            padding: 20px;
            font-size: 24px;
            font-weight: 500;
            border-top-left-radius: 4px;
	        border-top-right-radius: 4px;
            .rp-scenario-main-header {
                font-size: 20px;
            }
            @include for-size(tablet-landscape-up) {
                padding: 25px 40px;
            }
            @include for-size(desktop-up) {
                padding: $desktopPadding;
                font-size: 28px;
            }
            &.first-screen {
                padding: 15px 20px;
                .rp-scenario-main-header {
                    font-size: 18px;
                    font-weight: 400;
                    color: #333;
                    @include for-size(desktop-up) {
                        font-size: 26px !important;
                        line-height: 1;
                    }
                }
                 @include for-size(tablet-landscape-up) {
                    padding: 25px 40px;
                }
                @include for-size(desktop-up) {
                    padding: 30px 60px;
                }
            }
            color: #333333;
            border-bottom: 1px solid #ededed;
        }
        .rp-messenger-order-list-item-trigger {
            background: #fff;
            display: flex;
            align-items: center;
            line-height: 15px;
            padding: 16px 0;
            @include for-size(tablet-landscape-up) {
                padding: 25px 24px;
            }
            @include for-size(desktop-up){
                padding: 16px 22px;
            }
            @include for-size(desktop-up){
                padding: 20px 44px;
            }
            color: #000000;
            cursor: pointer;
            border-bottom: 1px solid #eeeeee;
            font-size: 22px;
            font-weight: 500;
            transition: border-bottom-color 0.3s;
            outline: none;

            .label {
                padding: 0 20px;
                font-size: 17px;
                font-weight: 400;
                @include for-size(desktop-up){
                    font-size: 18px;
                }
                font-weight: 00;
                line-height: 22px;
                word-break: break-word;
                color: #000000;
                font-family: $font;
            }

            .icon {
                margin: 0 20px 0 auto;
                transition: transform 0.3s;
                font-weight: 500;
                color: #4d4d4d;
                font-size: 16px;
                .scenario-right-arrow {
                    font-weight: 600;
                    font-size: 20px;
                }
            }
        }

        .rp-messenger-order-list-item-content {
            min-height: 50px;
            background: #fff;
            padding: 0 1rem 1rem;
            overflow: auto;

            .sub-content {
                padding-bottom: 1rem;
                font-size: 12px;
                color: #666666;
                font-weight: 500;
                word-break: break-word;
                align-items: center;
                display: flex;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .btn.rp-chat-with-us {
                padding: 0.45rem 1rem;
                font-size: 11px;
                display: flex;
                font-weight: 600;
                align-items: center;
                justify-content: center;
                color: #4d4d4d;
                border: 1px solid #4d4d4d;
                margin-top: 0;
                background-color: rgb(255, 255, 255);

                &.small {
                    padding: 0.7rem 1.2rem;
                    font-size: 12px;
                }
            }
        }
    }
</style>
